import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, BarChart3 } from "lucide-react";
import { publicStatisticsOverview } from "../../lib/api";

const COUNTRY_LABEL = { DE: "Deutschland", AT: "Österreich", CH: "Schweiz" };

export default function HomepageBarometerTeaser() {
  const [range, setRange] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    publicStatisticsOverview()
      .then(d => setRange(d.ranges?.find(r => r.indicator_key === "one_person_households_share")))
      .catch(() => setErr(true));
  }, []);

  const cards = range?.countries || [];
  if (err || !range) return null;

  return (
    <section className="py-20 bg-[#060810]" data-testid="homepage-barometer-teaser">
      <div className="container-sat">
        <div className="grid lg:grid-cols-2 gap-12 items-start">
          <div>
            <div className="text-[10px] tracking-[0.28em] uppercase text-[#D4AF37]/80 mb-3 flex items-center gap-2">
              <BarChart3 size={12} /> DACH-Gesellschaftsbarometer
            </div>
            <h2 className="text-3xl sm:text-4xl font-serif leading-tight mb-4 text-white">
              Wie wir lieben, leben und Familie gestalten, verändert sich.
            </h2>
            <p className="text-white/70 leading-relaxed mb-6">
              Amtliche Zahlen aus Deutschland, Österreich und der Schweiz machen
              Entwicklungen sichtbar. SAT setzt dort an, wo Zahlen enden: bei
              Bewusstsein, Selbstverantwortung und Beziehungskompetenz.
            </p>
            <Link to="/gesellschaftsbarometer"
                  data-testid="homepage-barometer-cta"
                  className="inline-flex items-center gap-2 px-5 py-3 bg-[#D4AF37] text-black rounded text-sm hover:bg-[#c19f2a]">
              DACH-Zahlen entdecken <ArrowRight size={14} />
            </Link>
          </div>

          <div className="space-y-3">
            {cards.map(c => (
              <div key={c.country}
                   className="border border-white/10 rounded-lg p-4 flex items-baseline justify-between"
                   data-testid={`teaser-card-${c.country}`}>
                <div>
                  <div className="text-3xl font-serif text-white">
                    {new Intl.NumberFormat("de-CH", { minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(c.value)} %
                  </div>
                  <div className="text-sm text-white/60 mt-1">
                    Einpersonenhaushalte · {c.reference_period}
                  </div>
                </div>
                <div className="text-xs text-[#D4AF37]/80 uppercase tracking-widest">
                  {COUNTRY_LABEL[c.country]}
                </div>
              </div>
            ))}
            <p className="text-xs text-white/45 leading-relaxed pt-2">
              Einpersonenhaushalt bedeutet nicht automatisch Single oder einsam.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
